<template>
  <div @click="handlePageClick">
    <el-form ref="form" style="width:1400px;">
      <el-space wrap>  
      <el-form-item label="">
        <el-input v-model="obj.searchValue" placeholder="名称/代码 搜索主力合约" @input="handleInput" @keyup.enter="handleEnter" clearable style="width: 250px;">
            <template #prefix>
            <el-icon class="el-input__icon"><search /></el-icon>
            </template>
        </el-input>
      </el-form-item>  
      <el-form-item label="">
        <el-select v-model="obj.intervalValue" style="width: 120px;">
          <!-- <template #prefix>
            <el-icon class="el-input__icon"><tickets /></el-icon>
          </template> -->
          <el-option
            v-for="item in obj.intervalList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>  
      <el-form-item label="开仓手数">
          <el-input-number v-model="obj.quantity" :min="1" :max="100" style="width: 120px;" :precision="0"/>
      </el-form-item>
      <el-form-item label="初始权益">
          <el-input-number v-model="obj.balance" :min="100000" :max="10000000" :step="100000" style="width: 150px;" :precision="0"/>
      </el-form-item>  
      </el-space>
      <br>
      <el-space wrap>
      <el-form-item label="多/空">
          <el-select v-model="obj.directionValue" style="width: 100px;" @change="handleSelectChange">
          <el-option
              v-for="item in obj.directionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          >
          </el-option>
          </el-select>
      </el-form-item>    
      <el-form-item label="开仓策略">
          <el-select v-model="obj.openStrategy" placeholder="请选择" style="width: 220px;">
          <el-option
              v-for="item in obj.openStrategyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          >
          </el-option>
          </el-select>
      </el-form-item>  
      <el-form-item label="平仓策略">
          <el-select v-model="obj.closeStrategy" placeholder="请选择" style="width: 220px;">
          <el-option
              v-for="item in obj.closeStrategyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          >
          </el-option>
          </el-select>
      </el-form-item>
      <el-form-item>
          <el-button type="primary" @click="onSubmit">开始回测</el-button>
      </el-form-item>
      </el-space>
    </el-form>
    <div style="width: 250px; max-height: 420px;" class='search-ul'>
      <div v-for="data in obj.filteredList" :key="data" class="search-li" @click="handleClick(data)">
        {{data['name']}} {{data['symbol']}} {{data['exchange']}}
        <span v-if="data['main'] === 1"> *主力 </span>
      </div>
    </div>
    <el-descriptions
        class="margin-top"
        title=""
        :column="4"
        border
        style="width:1200px"
    >
        <template #extra>
        <!-- <el-button type="primary" size="small">导出</el-button> -->
        </template>
        <el-descriptions-item width="100px">
          <template #label>
              <!-- <el-icon><tickets /></el-icon> -->
              收益合计
          </template>
          <span v-if="obj.profit>0" style="color:red">{{obj.profit}}</span>
          <span v-if="obj.profit<0" style="color:green">{{obj.profit}}</span>
          <span v-if="obj.profit==0">{{obj.profit}}</span>
        </el-descriptions-item>
        <el-descriptions-item width="100px">
          <template #label>
              <!-- <el-icon><tickets /></el-icon> -->
              手续费合计
          </template>
          {{obj.charge}}
        </el-descriptions-item>
        <el-descriptions-item width="100px">
          <template #label>
              <!-- <el-icon><tickets /></el-icon> -->
              手续费占比
          </template>
          {{obj.chargeRate}}%
        </el-descriptions-item>
        <el-descriptions-item width="100px">
          <template #label>
              <!-- <el-icon><tickets /></el-icon> -->
              净收益
          </template>
          <span v-if="obj.profit - obj.charge>0" style="color:red">{{obj.profit - obj.charge}}</span>
          <span v-if="obj.profit - obj.charge<0" style="color:green">{{obj.profit - obj.charge}}</span>
          <span v-if="obj.profit - obj.charge==0">{{obj.profit - obj.charge}}</span>
        </el-descriptions-item>
        <el-descriptions-item width="100px">
          <template #label>
              <!-- <el-icon><tickets /></el-icon> -->
              收益率
          </template>
          <span v-if="parseFloat(obj.rtn)>0" style="color:red">{{obj.rtn}}%</span>
          <span v-if="parseFloat(obj.rtn)<0" style="color:green">{{obj.rtn}}%</span>
          <span v-if="parseFloat(obj.rtn)==0">{{obj.rtn}}%</span>
        </el-descriptions-item>
        <el-descriptions-item width="100px">
          <template #label>
              <!-- <el-icon><tickets /></el-icon> -->
              交易次数
          </template>
          {{obj.tradeAmount}}
        </el-descriptions-item>
        <el-descriptions-item width="100px">
          <template #label>
              <!-- <el-icon><tickets /></el-icon> -->
              胜率
          </template>
          {{obj.winRate}}%
          <!-- <el-tag size="small">{{obj.winRate}}</el-tag> -->
        </el-descriptions-item>
        <el-descriptions-item width="100px">
          <template #label>
              <!-- <el-icon><tickets /></el-icon> -->
              盈亏比
          </template>
          <span v-if="obj.winLossRatio>1" style="color:red">{{obj.winLossRatio}}</span>
          <span v-if="obj.winLossRatio<1" style="color:green">{{obj.winLossRatio}}</span>
          <span v-if="obj.winLossRatio==1">{{obj.winLossRatio}}</span>
        </el-descriptions-item>
        <el-descriptions-item width="100px">
          <template #label>
              <!-- <el-icon><tickets /></el-icon> -->
              最大回撤
          </template>
          {{obj.drawBack}}%
          </el-descriptions-item>
        <el-descriptions-item width="100px">
          <template #label>
              <!-- <el-icon><tickets /></el-icon> -->
              最小权益
          </template>
          {{obj.minBalance}}
        </el-descriptions-item>
        <el-descriptions-item width="100px">
          <template #label>
              <!-- <el-icon><tickets /></el-icon> -->
              最大权益
          </template>
          {{obj.maxBalance}}
        </el-descriptions-item>
        <el-descriptions-item width="100px">
          <template #label>
              <!-- <el-icon><tickets /></el-icon> -->
              最终权益
          </template>
          {{obj.lastBalance}}
        </el-descriptions-item>
    </el-descriptions>
    <el-table :data="obj.tradeList" style="width: 1250px" height="100%" empty-text=" " :style="'height:'+ (this.$store.state.windowHeight - 350)  +'px'" :cell-style="cellStyle">
      <el-table-column fixed label="开仓日期" prop="oDate" width="110px" sortable />
      <el-table-column label="合约名称" prop="oName" width="110px" />
      <el-table-column label="多/空" prop="oDirection" width="80px" />
      <el-table-column label="价格" prop="oPrice" width="80px" />
      <el-table-column label="手数" prop="oQuantity" width="80px" />
      <el-table-column label="平仓日期" prop="cDate" width="110px" />
      <el-table-column label="合约名称" prop="cName" width="110px" />
      <el-table-column label="多/空" prop="cDirection" width="80px" />
      <el-table-column label="价格" prop="cPrice" width="80px" />
      <el-table-column label="手数" prop="cQuantity" width="80px" />
      <el-table-column label="收益" prop="profit" width="100px" sortable />
      <el-table-column label="手续费" prop="charge" width="100px" />
      <el-table-column label="净收益" prop="net" width="100px" sortable />
    </el-table>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { http } from '../util/http'
import { sum, findObjByField } from '../util/base'
import { ElMessage } from 'element-plus'
export default {
  setup () {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const obj = reactive({
      searchList: [],
      filteredList: [],
      searchValue: '',
      // intervalList: [{ value: 'MIN', label: '15分钟线' }, { value: 'H', label: '1小时线' }, { value: 'D', label: '日线' }],
      intervalList: [{ value: 'D', label: '日线' }],
      intervalValue: 'D',
      quantity: 1,
      balance: 100000,
      directionList: [
        { value: 0, label: '多' },
        { value: 1, label: '空' },
      ],
      directionValue: 0,
      directionLabel: '多',
      openStrategyList: [
        { value: 'Pre_Up_MA1', label: '站稳MA1' },
        { value: 'Pre_Down_MA1', label: '跌破MA1' },
        { value: 'Pre_Up_MA2', label: '站稳MA2' },
        { value: 'Pre_Down_MA2', label: '跌破MA2' },
        { value: 'Pre_Up_MA3', label: '站稳MA3' },
        { value: 'Pre_Down_MA3', label: '跌破MA3' },
        { value: 'Pre_MA_CROSSUP', label: 'MA金叉' },
        { value: 'Pre_MA_CROSSDOWN', label: 'MA死叉' },
        { value: 'Pre_MA_LONG', label: 'MA多头排列' },
        { value: 'Pre_MA_SHORT', label: 'MA空头排列' },

        { value: 'Pre_MACD_CROSSUP', label: 'MACD翻红' },
        { value: 'Pre_MACD_CROSSDOWN', label: 'MACD翻绿' },
        { value: 'Pre_MACD_2_CROSSUP', label: '短期MACD翻红' },
        { value: 'Pre_MACD_2_CROSSDOWN', label: '短期MACD翻绿' },
        { value: 'Pre_KDJ_CROSSUP', label: 'KDJ金叉' },
        { value: 'Pre_KDJ_CROSSDOWN', label: 'KDJ死叉' },
        { value: 'Pre_BOLL_CROSSUP_MID', label: '布林上穿中轨' },
        { value: 'Pre_BOLL_CROSSDOWN_MID', label: '布林下穿中轨' },

        { value: '多头持续', label: '多头持续' },
        { value: '多头持续  ', label: '空头持续' },
        { value: '多头修正', label: '多头修正' },
        { value: '空头修正', label: '空头修正' },
        { value: '多头回调启动', label: '多头回调启动' },
        { value: '空头回调启动', label: '空头回调启动' },
        { value: '多头回调持续', label: '多头回调持续' },
        { value: '空头回调持续', label: '空头回调持续' },
        { value: '多头启动', label: '多头启动' },
        { value: '空头启动', label: '空头启动' },
        
      ],
      closeStrategyList: [
        { value: 'Pre_Up_MA1', label: '站稳MA1' },
        { value: 'Pre_Down_MA1', label: '跌破MA1' },
        { value: 'Pre_Up_MA2', label: '站稳MA2' },
        { value: 'Pre_Down_MA2', label: '跌破MA2' },
        { value: 'Pre_Up_MA3', label: '站稳MA3' },
        { value: 'Pre_Down_MA3', label: '跌破MA3' },
        { value: 'Pre_MA_CROSSUP', label: 'MA金叉' },
        { value: 'Pre_MA_CROSSDOWN', label: 'MA死叉' },
        { value: 'Pre_MA_LONG', label: 'MA多头排列' },
        { value: 'Pre_MA_SHORT', label: 'MA空头排列' },

        { value: 'Pre_MACD_CROSSUP', label: 'MACD翻红' },
        { value: 'Pre_MACD_CROSSDOWN', label: 'MACD翻绿' },
        { value: 'Pre_MACD_2_CROSSUP', label: '短期MACD翻红' },
        { value: 'Pre_MACD_2_CROSSDOWN', label: '短期MACD翻绿' },
        { value: 'Pre_KDJ_CROSSUP', label: 'KDJ金叉' },
        { value: 'Pre_KDJ_CROSSDOWN', label: 'KDJ死叉' },
        { value: 'Pre_BOLL_CROSSUP_MID', label: '布林上穿中轨' },
        { value: 'Pre_BOLL_CROSSDOWN_MID', label: '布林下穿中轨' },

        { value: '多头持续', label: '多头持续' },
        { value: '多头持续  ', label: '空头持续' },
        { value: '多头修正', label: '多头修正' },
        { value: '空头修正', label: '空头修正' },
        { value: '多头回调启动', label: '多头回调启动' },
        { value: '空头回调启动', label: '空头回调启动' },
        { value: '多头回调持续', label: '多头回调持续' },
        { value: '空头回调持续', label: '空头回调持续' },
        { value: '多头启动', label: '多头启动' },
        { value: '空头启动', label: '空头启动' },
      ],
      openStrategy: '',
      closeStrategy: '',
      tradeList: [],
      profit: 0,
      charge: 0,
      chargeRate: 0,
      tradeAmount: 0,
      winRate: 0,
      winLossRatio: 1,
      rtn: 0,
      drawBack: 0,
      minBalance: 0,
      maxBalance: 0,
      lastBalance: 0
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      vueEvent.emit('navbarMenuIdxEvent', '11') 
      vueEvent.emit('sidebarMenuIdxEvent', '')
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.backtestData === ''){
        // 无缓存，从后台请求数据
        renderSelect()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 获取数据渲染下拉框
    const renderSelect = () => {
      let formData = new FormData()
      formData.append("category", "main")
      http({
        url: '/contract',
        method: 'post',
        data: formData
      }).then((res) => {
        obj.searchList = res.data.data
      })
    }

    // 搜索框输入事件
    const handleInput = () => {
      if (obj.searchValue.trim() === '') {
        obj.filteredList = []
        return
      }
      obj.filteredList = obj.searchList.filter(item => item['name'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()) ||
      item['symbol'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()))
    }

    // 搜索框回车事件
    const handleEnter = () => {
      if (obj.filteredList.length !== 0){
        obj.searchValue = obj.filteredList[0]['name']
        obj.filteredList = []
      }
    }
    
    // 搜索结果点击事件
    const handleClick = (data) => {
      obj.searchValue = data['name']
      obj.filteredList = []
    }

    // 页面空白点击事件
    const handlePageClick = () => {
      obj.filteredList = []
    }

    // 下拉框选择事件
    const handleSelectChange = (value) => {
      // 下拉框value转为label
      const tempObj = findObjByField(obj.directionList, 'value', value)
      obj.directionLabel = tempObj.label
    }

    // 导出excel功能
    const exportExcel = () => {
      /* generate workbook object from table */
      let wb = XLSX.utils.table_to_book(document.querySelector('#rebateSetTable'));
      /* get binary string as output */
      let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
      try {
          FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'data.xlsx');
      } catch (e)
      {
          if (typeof console !== 'undefined')
              console.log(e, wbout)
      }
      return wbout
    }

    // 获取数据渲染图表
    const onSubmit = () => {
      if (!formCheck()){
        return
      }
      let formData = new FormData()
      formData.append("name", obj.searchValue)
      formData.append("interval", obj.intervalValue)
      formData.append("direction", obj.directionLabel)
      formData.append("quantity", obj.quantity)
      formData.append("balance", obj.balance)
      formData.append("open_strategy", obj.openStrategy)
      formData.append("close_strategy", obj.closeStrategy)
      http({
        url: `/backtest`,
        method: 'post',
        data: formData
      }).then((res) => {
        console.log(res.data.data)
        processData(res)
        setStore()
      })
    }

    // 表单check
    const formCheck = () => {
      if (obj.searchValue.trim() === ''){
        ElMessage.error('请输入合约名称')
        return false
      }
      if (obj.openStrategy.trim() === ''){
        ElMessage.error('请选择开仓策略')
        return false
      }
      if (obj.closeStrategy.trim() === ''){
        ElMessage.error('请选择平仓策略')
        return false
      }
      return true
    }

    // 加工处理数据
    const processData = (res) => {
      var long = res.data.data[0] // 做多合约
      var short = res.data.data[1] // 做空合约
      var tradeList = res.data.data[2] // 交易记录
      var profit = res.data.data[3] // 收益合计  
      var charge = res.data.data[4] // 手续费合计
      var chargeRate = res.data.data[5] // 手续费占比
      var tradeAmount = res.data.data[6] // 交易次数
      var winRate = res.data.data[7] // 胜率
      var winLossRatio = res.data.data[8] // 盈亏比
      var drawBack = res.data.data[9] // 最大回撤
      var minBalance = res.data.data[10] // 最小权益
      var maxBalance = res.data.data[11] // 最大权益
      var rtn = res.data.data[12] // 收益率

      const macdList = []
      tradeList.forEach(element => {
        macdList.push({ oDate: element[0], oName: element[1], oDirection: element[2], oPrice: element[3], oQuantity: element[4],
        cDate: element[5], cName: element[6], cDirection: element[7], cPrice: element[8], cQuantity: element[9],
        profit: element[10], charge: element[11], net: element[12] })
      });
      obj.tradeList = macdList
      obj.profit = sum(profit)
      obj.charge = sum(charge)
      obj.chargeRate = chargeRate.toFixed(2)
      obj.tradeAmount = tradeAmount
      obj.winRate = winRate
      obj.winLossRatio = winLossRatio
      obj.drawBack = drawBack
      obj.minBalance = minBalance
      obj.maxBalance = maxBalance
      obj.lastBalance = obj.profit - obj.charge + obj.balance
      obj.rtn = rtn
      return macdList
    }

    // 保存至store
    const setStore = () => {
      var storeObj = {'searchList':obj.searchList,
                      'filteredList': obj.filteredList,
                      'searchValue': obj.searchValue,
                      'intervalValue': obj.intervalValue,
                      'quantity': obj.quantity,
                      'balance': obj.balance,
                      'directionValue': obj.directionValue,
                      'directionLabel': obj.directionLabel,
                      'openStrategy': obj.openStrategy,
                      'closeStrategy': obj.closeStrategy,
                      'tradeList': obj.tradeList,
                      'profit': obj.profit,
                      'charge': obj.charge,
                      'chargeRate': obj.chargeRate,
                      'tradeAmount': obj.tradeAmount,
                      'winRate': obj.winRate,
                      'winLossRatio': obj.winLossRatio,
                      'rtn': obj.rtn,
                      'drawBack': obj.drawBack,
                      'minBalance': obj.minBalance,
                      'maxBalance': obj.maxBalance,
                      'lastBalance': obj.lastBalance,
                      }
      store.commit('setBacktestData', storeObj) // 缓存数据                  
    }

     // 获取Store
    const getStore = () => {
      obj.searchList = store.state.backtestData.searchList
      obj.filteredList = store.state.backtestData.filteredList
      obj.searchValue = store.state.backtestData.searchValue
      obj.intervalValue = store.state.backtestData.intervalValue
      obj.quantity = store.state.backtestData.quantity
      obj.balance = store.state.backtestData.balance
      obj.directionValue = store.state.backtestData.directionValue
      obj.directionLabel = store.state.backtestData.directionLabel
      obj.openStrategy = store.state.backtestData.openStrategy
      obj.closeStrategy = store.state.backtestData.closeStrategy
      obj.tradeList = store.state.backtestData.tradeList
      obj.profit = store.state.backtestData.profit
      obj.charge = store.state.backtestData.charge
      obj.chargeRate = store.state.backtestData.chargeRate
      obj.tradeAmount = store.state.backtestData.tradeAmount
      obj.winRate = store.state.backtestData.winRate
      obj.winLossRatio = store.state.backtestData.winLossRatio
      obj.rtn = store.state.backtestData.rtn
      obj.drawBack = store.state.backtestData.drawBack
      obj.minBalance = store.state.backtestData.minBalance
      obj.maxBalance = store.state.backtestData.maxBalance
      obj.lastBalance = store.state.backtestData.lastBalance
    }

    // 表格单元格样式
    const cellStyle = (row) => {
      if (row.row.profit > 0 && row.columnIndex === 10) {
        return {color: 'red'}
      } else if (row.row.profit < 0 && row.columnIndex === 10) {
        return {color: 'green'}
      }
      if (row.row.net > 0 && row.columnIndex === 12) {
        return {color: 'red'}
      } else if (row.row.net < 0 && row.columnIndex === 12) {
        return {color: 'green'}
      }
    }

    return {
      obj,
      store,
      handleInput,
      handleEnter,
      handlePageClick,
      handleSelectChange,
      handleClick,
      onSubmit,
      cellStyle
    }
  }

}
</script>
<style lang="scss" scoped>
/* ================================
Components
Search
================================= */
.search-ul {
  position: absolute;
  left: 80px;
  top: 95px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}
.search-li {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}
.search-li:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
</style>
